import { createPortal } from "react-dom";
import {
    rightDrawerOpenAtom,
    RightDrawerSize,
    rightDrawerSizeAtom,
} from "../state";
import { useAtom, useAtomValue } from "jotai";
import { Fragment, useEffect, useState } from "react";
import { useMediaQuery } from "@/ui/hooks/useMediaQuery";

export function RightDrawerContent({
    children,
    onClose,
    size = RightDrawerSize.DEFAULT,
}: {
    children: React.ReactNode;
    onClose?: () => void;
    size?: RightDrawerSize;
}) {
    const [needsCloseResolution, setNeedsCloseResolution] = useState(false);
    const isMobile = useMediaQuery("(max-width: 640px)");
    const rightDrawerOpen = useAtomValue(rightDrawerOpenAtom);
    const [rightDrawerSize, setRightDrawerSize] = useAtom(rightDrawerSizeAtom);
    const mobilePortalContainer = document.getElementById(
        "mobile-right-drawer-content",
    );

    const portalContainer = document.getElementById("right-drawer-content");

    useEffect(() => {
        if (size !== rightDrawerSize) {
            setRightDrawerSize(size);
        }
    }, [size, rightDrawerSize, setRightDrawerSize]);

    useEffect(() => {
        if (rightDrawerOpen) {
            setNeedsCloseResolution(true);
        }
    }, [rightDrawerOpen, setNeedsCloseResolution]);

    useEffect(() => {
        if (!rightDrawerOpen && needsCloseResolution && onClose) {
            onClose();
        }
    }, [onClose, rightDrawerOpen, needsCloseResolution]);

    if (!portalContainer) {
        return null;
    }

    return (
        <Fragment>
            {portalContainer &&
                !isMobile &&
                createPortal(children, portalContainer)}
            {isMobile &&
                mobilePortalContainer &&
                createPortal(children, mobilePortalContainer)}
        </Fragment>
    );
}
